import * as React from "react";
import {Container, Nav, Navbar} from "react-bootstrap";
import {Link} from "react-router-dom";
import {UserFullState} from "../state/cache/UserFullState";
import {ScrollService} from "../service/ScrollService";

export interface NavigationBarProps {
    currentUserState: UserFullState;
}

export function NavigationBar(props: NavigationBarProps) {
    return (
        <Navbar bg="light" expand="lg" fixed="top">
            <Container>
                <Navbar.Brand><strong><Link className="navbar-brand" to="/" onClick={ScrollService.scrollToTop}>StatusMatcher</Link></strong></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Link className="nav-link" to="/airlines" onClick={ScrollService.scrollToTop}>Airlines</Link>
                        <Link className="nav-link" to="/hotels" onClick={ScrollService.scrollToTop}>Hotels</Link>
                        <Link className="nav-link" to="/auto" onClick={ScrollService.scrollToTop}>Auto</Link>
                        <Link className="nav-link" to="/guide" onClick={ScrollService.scrollToTop}>Guide</Link>
                        <Link className="nav-link" to="/report/create" onClick={ScrollService.scrollToTop}>Create Report</Link>
                        {props.currentUserState.userFull ?
                            <Link className="nav-link d-lg-none" to="/logout" onClick={ScrollService.scrollToTop}>Logout</Link>
                            :
                            <><Link className="nav-link d-lg-none" to="/login" onClick={ScrollService.scrollToTop}>Login</Link>
                                <Link className="nav-link d-lg-none" to="/register" onClick={ScrollService.scrollToTop}>Register</Link></>
                        }
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}